import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Box, Typography, Button } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';

import { TextField } from '@material-ui/core';

import Messages from '../defs/messages';

import { useForm, Controller } from 'react-hook-form';
import { usePostSendEmailMutation } from '../store/apiSlice';
import { handlePageChange } from '../utils/ally';
import { Helmet } from 'react-helmet-async';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  grid: {
    borderColor: theme.palette.secondary,
    borderBottom: '1px solid',
    marginTop: theme.spacing(1),
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
}));

function Contact() {
  const classes = useStyles();
  const msg = Messages.LOGINFORM;

  const [sendEmail] = usePostSendEmailMutation();

  const headingRef = useRef(null);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    defaultValues: { name: '', email: '', message: '' },
  });

  const requiredRule = {
    required: { value: true, message: msg.FIELD_REQUIRED },
  };

  const onSubmit = async (values) => {
    await sendEmail(values);
    reset();
  };

  return (
    <div className={classes.root}>
      <Helmet>
        <title>Контакт</title>
      </Helmet>
      <CssBaseline />
      <Container maxWidth="lg" className={classes.container}>
        <Paper className={classes.paper}>
          <Typography
            ref={headingRef}
            className={classes.title}
            component="h1"
            variant="h4"
            role="alert"
          >
            Контакт
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Box className={classes.flex}>
              <Controller
                name="name"
                rules={requiredRule}
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Име"
                    type="text"
                    error={!!errors.name}
                    helperText={errors?.name?.message}
                    id="name"
                    {...field}
                  />
                )}
              />
              <Controller
                name="email"
                rules={requiredRule}
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Имейл"
                    type="email"
                    error={!!errors.email}
                    helperText={errors?.email?.message}
                    id="email"
                    {...field}
                  />
                )}
              />
              <Controller
                name="message"
                rules={requiredRule}
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Съобщение"
                    id="message"
                    type="text"
                    error={!!errors.message}
                    helperText={errors?.message?.message}
                    multiline={true}
                    minRows={4}
                    variant="outlined"
                    {...field}
                  />
                )}
              />
              <Button type="submit" color="primary" variant="outlined">
                Изпрати
              </Button>
              {isSubmitSuccessful && (
                <Typography>Съобщението Ви бе изпратено успешно!</Typography>
              )}
            </Box>
          </form>
        </Paper>
      </Container>
    </div>
  );
}

export default Contact;
